var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _vm.disclosedData
              ? _c("h1", [_vm._v(_vm._s(_vm.disclosedData.name))])
              : _vm.pseudonym
              ? _c("h1", [_vm._v(_vm._s(_vm.pseudonym.label))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("VitaContent", {
              attrs: {
                "job-id": _vm.jobId,
                "job-profile-id": _vm.jobProfile.id,
                "pseudonym-id": _vm.pseudonym.id
              },
              on: {
                loaded: function($event) {
                  _vm.loadedVita = true
                },
                close: function($event) {
                  return _vm.$emit("hidden")
                }
              },
              scopedSlots: _vm._u(
                [
                  _vm.withActions && _vm.loadedVita
                    ? {
                        key: "after-matching-overview",
                        fn: function() {
                          return [
                            _c("Actions", {
                              ref: "actionsTop",
                              staticClass:
                                "job-list-item-actions on-white-background d-inline-block mb-3",
                              attrs: {
                                "job-profile-list-item": _vm.jobProfileListItem,
                                "job-id": _vm.jobId,
                                applicant: _vm.applicant,
                                permissions: _vm.permissions,
                                "initial-exclusion-type":
                                  _vm.initialExclusionType
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _vm.withActions && _vm.loadedVita
              ? _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "job-list-item-actions on-white-background"
                      },
                      [
                        _c("Actions", {
                          ref: "actionsBottom",
                          attrs: {
                            "job-profile-list-item": _vm.jobProfileListItem,
                            "job-id": _vm.jobId,
                            applicant: _vm.applicant,
                            permissions: _vm.permissions,
                            "initial-exclusion-type": _vm.initialExclusionType
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("ContactApplicant", {
                      staticClass: "ml-md-5 mt-2 mt-md-0",
                      attrs: {
                        "initial-in-contacting":
                          _vm.applicant.communication.hasOngoingConversation,
                        "waiting-for-acceptance-message":
                          _vm.applicant.communication
                            .waitingForAcceptanceMessage,
                        "job-id": _vm.jobId,
                        "job-profile-id": _vm.jobProfile.id,
                        applicant: _vm.applicant
                      },
                      on: { contacted: _vm.contacted }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }